const actions = {
	CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGOUT: 'LOGOUT',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_ERROR: 'LOGIN_ERROR',
	GOOGLE_OTHERDOCS: 'GOOGLE_OTHERDOCS',
	GET_GOOGLE_OTHERDOCS: 'GET_GOOGLE_OTHERDOCS',
	CLEAR_GOOGLE_OTHERDOCS: 'CLEAR_GOOGLE_OTHERDOCS',
	checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
	login: (payload, props) => ({
		type: actions.LOGIN_REQUEST,
		payload,
		props
	}),
	logout: () => ({
		type: actions.LOGOUT
	}),
	setGoogleOtherDocs: (payload) => ({
		type: actions.GOOGLE_OTHERDOCS,
		payload
	})
};

export default actions;
